import { render, staticRenderFns } from "./Llamadas.vue?vue&type=template&id=12c7a682&"
import script from "./Llamadas.vue?vue&type=script&lang=js&"
export * from "./Llamadas.vue?vue&type=script&lang=js&"
import style0 from "./Llamadas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports